import { fromJS } from 'immutable';
import routeDetails from 'react/api/actions/routeDetails';

const initialState = fromJS({
  toolbarLayers: {},
  activeLayers: {}
});

export default (state = initialState, action = {}) => {
  if (action.type === routeDetails.actions.updateToolbarLayers) {
    return state.mergeDeep({
      toolbarLayers: {
        [action.payload.routeId]: action.payload.positionSources.map(
          ({ attributes: { id, positionSource } }) => ({
            id,
            ...positionSource
          })
        )
      }
    });
  }

  if (action.type === routeDetails.actions.activeLayer) {
    const { routeId, positionSource: newLayer } = action.payload;
    const currentLayers = state.getIn(['activeLayers', String(routeId)], fromJS([]));
    const filteredLayers = currentLayers.filter((l) => l.get('id') !== newLayer.id);

    return state.setIn(
      ['activeLayers', String(routeId)],
      filteredLayers.push(fromJS(newLayer))
    );
  }

  if (action.type === routeDetails.actions.inactiveLayer) {
    const { routeId, layerId } = action.payload;
    const currentLayers = state.getIn(['activeLayers', String(routeId)], fromJS([]));
    const filteredLayers = currentLayers.filter((l) => l.get('id') !== layerId);
    return state.setIn(['activeLayers', String(routeId)], filteredLayers);
  }

  if (action.type === routeDetails.actions.activateAllLayers) {
    const { routeId } = action.payload;
    const toolbarLayers = state.getIn(['toolbarLayers', String(routeId)], fromJS([]));
    return state.setIn(['activeLayers', String(routeId)], toolbarLayers);
  }

  if (action.type === routeDetails.actions.deactivateAllLayers) {
    const { routeId } = action.payload;
    return state.setIn(['activeLayers', String(routeId)], fromJS([]));
  }

  return state;
};
